var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('full-page',{ref:"fullpage",attrs:{"options":_vm.options,"id":"fullpage"}},[_c('Index'),_c('ClosedEye'),_c('PupilTrack'),_c('Programs'),_c('Team')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }